import React from 'react'

import { useState, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CardContext from '../context/CardContext';
import CardContent from './cardContent';
import CardEdit from './cardEdit';

export default function Card({ img, link, title, text, index }) {
    const [editContentMode, setEditContentMode] = useState(false)
    const { removeCard } = useContext(CardContext)

    const toggleEditMode = () => {
        setEditContentMode(!editContentMode)
    }

    return (
        <li key={index} className={`${editContentMode ? 'editing-card' : ''}`}>
            <button className="card-remove" onClick={ () => { removeCard(index) }}><FontAwesomeIcon icon="trash-can" fade inverse /></button>
            <button className="card-edit" onClick={ () => { setEditContentMode(!editContentMode) }}>{editContentMode ? <FontAwesomeIcon icon="arrow-left" inverse /> : <FontAwesomeIcon icon="pen-to-square" fade inverse />}</button>
            <CardContent img={img} link={link} title={title} text={text} />
            {editContentMode ? <CardEdit img={img} link={link} title={title} text={text} index={index} handleFinishedEdit={toggleEditMode} /> : ''}
        </li>
    )
}
